/**
 * Clean demo entry for /canonicalize — no carried source until the user acts.
 */
import {
  clearContinuityCarry,
  coalesceContinuityCarry,
  emptyContinuityCarry,
  saveContinuityCarry,
  type CanonicallsContinuityCarry,
} from "./canonicallsContinuityCarry";

export const CANONICALLS_FRESH_DEMO_PARAM = "fresh" as const;

export function isCanonicallsFreshDemoSearch(search: string): boolean {
  const raw = new URLSearchParams(search).get(CANONICALLS_FRESH_DEMO_PARAM);
  if (!raw) return false;
  const v = raw.trim().toLowerCase();
  return v === "1" || v === "true" || v === "yes";
}

export function isCanonicallsFreshCanonicalize(pathname: string, search: string): boolean {
  const p = pathname.replace(/\/$/, "") || "/";
  return p === "/canonicalize" && isCanonicallsFreshDemoSearch(search);
}

/** Reset carry used by canonicalize traversal; preserved cross-post records are kept. */
export function clearCanonicallsDemoTraversalState(): void {
  clearContinuityCarry();
}

export function emptyCanonicalizeDemoCarry(): CanonicallsContinuityCarry {
  return saveContinuityCarry({
    ...emptyContinuityCarry(),
    lineageState: "active",
    lastTraversalStep: "origin",
    postId: null,
    sourceTitle: null,
    actor: null,
    digest: null,
    evidence: [],
    verificationState: "none",
    representationCount: 0,
    representations: [],
    agreementLinked: false,
  });
}

export function normalizeCanonicalizeFreshUrl(search: string): URLSearchParams {
  const next = new URLSearchParams(search);
  next.delete("post");
  next.delete("cross_post");
  next.delete("sha");
  next.delete(CANONICALLS_FRESH_DEMO_PARAM);
  if (!next.get("traverse") || next.get("traverse") === "canonicalize") {
    next.set("traverse", "origin");
  }
  return next;
}

export function applyFreshCanonicalizeCarry(): CanonicallsContinuityCarry {
  clearCanonicallsDemoTraversalState();
  return coalesceContinuityCarry(emptyCanonicalizeDemoCarry());
}
